import type { AxiosResponse } from 'axios';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
interface Model<I, M> extends Function {
    new(item: I): M;
}

export function modelFactory<I, M>(model: Model<I, M>): (item: I) => M {
    return (item) => new model(item);
}

export function listModelFactory<I, M>(model: Model<I, M>): (items: I[]) => M[] {
    return (items) => items.map(modelFactory(model));
}

type AssemblerResult<I, M> = (response: AxiosResponse<I>) => AxiosResponse<M>

export function assemblerModel<I, M>(factory: ReturnType<typeof modelFactory<I, M>>): AssemblerResult<I, M> {
    return (response) => ({ ...response, data: factory(response.data) });
}

export function extractData<T>(response: AxiosResponse<T>): T {
    return response.data;
}

export function makeVoid(): void {
    // do nothing
}
